import { useState } from "react";
import { useSelector } from "react-redux";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import { Badge } from "react-bootstrap";
import { Translate } from "../../../../Enums/Tranlate";
import BookingService from "../../../../../services/BookingService";
import DeleteModal from "../../../../common/DeleteModal";

const CardItem = ({ item, setAddModal, index, setItem, setShouldUpdate }) => {
	const [status, setStatus] = useState(item.status);
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const bookingService = new BookingService();

	const changeStatus = () => {
		// categoryService
		// 	.toggleStatus(item?.id, { status: !item?.status })
		// 	.then((res) => {
		// 		if (!!res?.status) {
		// 			setStatus(!item?.status);
		// 			setShouldUpdate((prev) => !prev);
		// 			setStatusModal(false);
		// 		}
		// 	});
	};

	return (
		<tr key={index} className="text-center">
			<td>{item?.court[`name_${lang}`] || "-"}</td>
			<td>{item?.date?.split("T")[0] || "-"}</td>
			<td>{item?.time || "-"}</td>
			<td>{item?.phone || "-"}</td>

			<td>
				<Badge
					className="text-capitalize cursor-pointer"
					variant={`${status === "confirm" ? "success" : "danger"} light`}>
					{Translate[lang][status]}
				</Badge>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_all_booking") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("delete_all_booking") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.court[`name_${lang}`]}
					deletedItem={item}
					modelService={bookingService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
